import { Text } from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';

import { useArchiveInitiative } from '@services/query-services/initiatives.query-service';
import { useMutationToast } from '@util/hooks';
import DeleteConfirmationModal from '@components/general/modals/delete-confirmation-modal.component';

const DeleteCollectionModal = ({ onDelete, collectionId, disclosure }) => {
  const { mutateAsync: archiveCollection, isLoading: isArchivingCollection } =
    useArchiveInitiative();
  const { onSuccess: onDeleteSuccess, onError: onDeleteError } = useMutationToast(
    'collection',
    'delete'
  );
  const queryClient = useQueryClient();

  const onCollectionDelete = async () => {
    await archiveCollection(
      { id: collectionId, value: true },
      { onSuccess: onDeleteSuccess, onError: onDeleteError }
    );
    onDelete?.();
    await queryClient.invalidateQueries({ queryKey: ['initiatives'], refetchType: 'all' });
    disclosure.onClose();
  };

  return (
    <DeleteConfirmationModal
      disclosure={disclosure}
      headerText='Delete Collection Permanently?'
      onConfirmDelete={onCollectionDelete}
      isDeleting={isArchivingCollection}
    >
      <Text>Are you sure you want to delete this collection?</Text>
    </DeleteConfirmationModal>
  );
};

export default DeleteCollectionModal;
